<div class="download-invoices">
  <div class="download-invoices__icon">
    <sl-spinner *ngIf="loading"></sl-spinner>
    <sl-icon name="check-circle" *ngIf="!loading"></sl-icon>
  </div>
  <div>
    <sl-label size="large" *ngIf="loading" i18n>Downloading invoices</sl-label>
    <sl-label size="large" *ngIf="!loading" i18n>Downloading complete</sl-label>
  </div>
  <sl-label size="small" color="medium" multiline i18n class="mb-6">Please wait while invoices are being retrieved.</sl-label>
  <sl-button type="primary" (click)="close()">Close</sl-button>
</div>